// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Typographie */

/* CSS reset */

html, body, div, span, applet, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym, address, big, cite, code,
del, dfn, em, img, ins, kbd, q, s, samp,
small, strike, strong, sub, sup, tt, var,
b, u, i, center,
dl, dt, dd, ol, ul, li,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, embed,
figure, figcaption, footer, header, hgroup,
menu, nav, output, ruby, section, summary,
time, mark, audio, video, .page-content {
	margin: 0;
	padding: 0;
	border: 0;
	font-size: 100%;
	font: inherit;
}

/* 1. Use a more-intuitive box-sizing model */
*, *::before, *::after {
  box-sizing: border-box;
}

html {
    font-size: 62.5%; /* 1rem = 10px */
    /* Gouttiere de barre de defilement toujours reservee : sans elle, le verrou de scroll ci-dessous
       fait disparaitre la barre a l'ouverture d'une modale, et toute la page se decale d'un cran. */
    scrollbar-gutter: stable;
}

/* ---------------------------------------------------------------------------------------------
   Verrou de scroll global : une modale ouverte, ou qu'elle soit, fige la page derriere elle.
   Selection par SOUS-CHAINE et non par liste : ce projet compte 23 noms de calques distincts
   (\`modal-overlay\`, \`modal-backdrop\`, \`modal-articles-overlay\`, \`suggerer-lot-backdrop\`,
   \`readonly-ref-overlay\`...). Une liste explicite serait morte au prochain nom invente ; la
   sous-chaine couvre aussi ceux qui n'existent pas encore.
   Ce que ca suppose, et qui a ete VERIFIE sur les 23 : chaque calque est rendu CONDITIONNELLEMENT
   (\`{isOpen && ...}\` ou une garde equivalente). Sa presence dans le DOM vaut donc "modale ouverte".
   Un calque qui serait rendu en permanence et masque en CSS figerait la page pour de bon — c'est la
   seule chose a verifier avant d'ajouter un nom en \`-overlay\` / \`-backdrop\`.
   Pose sur \`html\` et non \`body\` : c'est lui le porteur du defilement. \`body { overflow: hidden }\` ne
   fige la page que par propagation vers le viewport, et seulement tant que \`html\` reste \`visible\` —
   une dependance qu'on n'a aucune raison de prendre. Meme forme que le verrou deja en place pour les
   <dialog> natifs (\`html:has(dialog[open])\`, Marche.css). */
html:has([class*="overlay"]),
html:has([class*="backdrop"]) {
  overflow: hidden;
}

body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  /* 5. Improve text rendering */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* 4. Add accessible line-height */
  min-width: 390px;
  margin: auto ;
  color: #2C3948;
  font-size: 1.4rem /* 14px */;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* 6. Improve media defaults */
img, picture, video, canvas, svg {
  display: block;
  max-width: 100%;
}

/* 7. Inherit fonts for form controls */
input, button, textarea, select {
  font: inherit;
}

/* 8. Avoid text overflows */
p, h1, h2, h3, h4, h5, h6 {
  overflow-wrap: break-word;
}

/* 9. Improve line wrapping */
p {
  text-wrap: pretty;
}

h1, h2, h3, h4, h5, h6 {
  text-wrap: balance;
}

article, aside, details, figcaption, figure,
footer, header, hgroup, menu, nav, section {
	display: block;
}

ul {
	list-style: none;
}

a, a:visited, a:hover {
    text-decoration: none;
}

button {
    cursor: pointer;
    background: transparent;
    border: none;
    padding: 0;
    font: inherit;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAGhB,cAAc;;AAEd;;;;;;;;;;;;;CAaC,SAAS;CACT,UAAU;CACV,SAAS;CACT,eAAe;CACf,aAAa;AACd;;AAEA,6CAA6C;AAC7C;EACE,sBAAsB;AACxB;;AAEA;IACI,gBAAgB,EAAE,gBAAgB;IAClC;oGACgG;IAChG,wBAAwB;AAC5B;;AAEA;;;;;;;;;;;;;4DAa4D;AAC5D;;EAEE,gBAAgB;AAClB;;AAEA;EACE;;cAEY;EACZ,8BAA8B;EAC9B,mCAAmC;EACnC,kCAAkC;EAClC,kCAAkC;EAClC,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE;aACW;AACb;;AAEA,8BAA8B;AAC9B;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,uCAAuC;AACvC;EACE,aAAa;AACf;;AAEA,4BAA4B;AAC5B;EACE,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;CAEC,cAAc;AACf;;AAEA;CACC,gBAAgB;AACjB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,YAAY;IACZ,UAAU;IACV,aAAa;AACjB","sourcesContent":["/* Typographie */\r\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');\r\n\r\n/* CSS reset */\r\n\r\nhtml, body, div, span, applet, object, iframe,\r\nh1, h2, h3, h4, h5, h6, p, blockquote, pre,\r\na, abbr, acronym, address, big, cite, code,\r\ndel, dfn, em, img, ins, kbd, q, s, samp,\r\nsmall, strike, strong, sub, sup, tt, var,\r\nb, u, i, center,\r\ndl, dt, dd, ol, ul, li,\r\nfieldset, form, label, legend,\r\ntable, caption, tbody, tfoot, thead, tr, th, td,\r\narticle, aside, canvas, details, embed,\r\nfigure, figcaption, footer, header, hgroup,\r\nmenu, nav, output, ruby, section, summary,\r\ntime, mark, audio, video, .page-content {\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n\tborder: 0;\r\n\tfont-size: 100%;\r\n\tfont: inherit;\r\n}\r\n\r\n/* 1. Use a more-intuitive box-sizing model */\r\n*, *::before, *::after {\r\n  box-sizing: border-box;\r\n}\r\n\r\nhtml {\r\n    font-size: 62.5%; /* 1rem = 10px */\r\n    /* Gouttiere de barre de defilement toujours reservee : sans elle, le verrou de scroll ci-dessous\r\n       fait disparaitre la barre a l'ouverture d'une modale, et toute la page se decale d'un cran. */\r\n    scrollbar-gutter: stable;\r\n}\r\n\r\n/* ---------------------------------------------------------------------------------------------\r\n   Verrou de scroll global : une modale ouverte, ou qu'elle soit, fige la page derriere elle.\r\n   Selection par SOUS-CHAINE et non par liste : ce projet compte 23 noms de calques distincts\r\n   (`modal-overlay`, `modal-backdrop`, `modal-articles-overlay`, `suggerer-lot-backdrop`,\r\n   `readonly-ref-overlay`...). Une liste explicite serait morte au prochain nom invente ; la\r\n   sous-chaine couvre aussi ceux qui n'existent pas encore.\r\n   Ce que ca suppose, et qui a ete VERIFIE sur les 23 : chaque calque est rendu CONDITIONNELLEMENT\r\n   (`{isOpen && ...}` ou une garde equivalente). Sa presence dans le DOM vaut donc \"modale ouverte\".\r\n   Un calque qui serait rendu en permanence et masque en CSS figerait la page pour de bon — c'est la\r\n   seule chose a verifier avant d'ajouter un nom en `-overlay` / `-backdrop`.\r\n   Pose sur `html` et non `body` : c'est lui le porteur du defilement. `body { overflow: hidden }` ne\r\n   fige la page que par propagation vers le viewport, et seulement tant que `html` reste `visible` —\r\n   une dependance qu'on n'a aucune raison de prendre. Meme forme que le verrou deja en place pour les\r\n   <dialog> natifs (`html:has(dialog[open])`, Marche.css). */\r\nhtml:has([class*=\"overlay\"]),\r\nhtml:has([class*=\"backdrop\"]) {\r\n  overflow: hidden;\r\n}\r\n\r\nbody {\r\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\r\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\r\n    sans-serif;\r\n  /* 5. Improve text rendering */\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n  /* 4. Add accessible line-height */\r\n  min-width: 390px;\r\n  margin: auto ;\r\n  color: #2C3948;\r\n  font-size: 1.4rem /* 14px */;\r\n}\r\n\r\ncode {\r\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\r\n    monospace;\r\n}\r\n\r\n/* 6. Improve media defaults */\r\nimg, picture, video, canvas, svg {\r\n  display: block;\r\n  max-width: 100%;\r\n}\r\n\r\n/* 7. Inherit fonts for form controls */\r\ninput, button, textarea, select {\r\n  font: inherit;\r\n}\r\n\r\n/* 8. Avoid text overflows */\r\np, h1, h2, h3, h4, h5, h6 {\r\n  overflow-wrap: break-word;\r\n}\r\n\r\n/* 9. Improve line wrapping */\r\np {\r\n  text-wrap: pretty;\r\n}\r\n\r\nh1, h2, h3, h4, h5, h6 {\r\n  text-wrap: balance;\r\n}\r\n\r\narticle, aside, details, figcaption, figure,\r\nfooter, header, hgroup, menu, nav, section {\r\n\tdisplay: block;\r\n}\r\n\r\nul {\r\n\tlist-style: none;\r\n}\r\n\r\na, a:visited, a:hover {\r\n    text-decoration: none;\r\n}\r\n\r\nbutton {\r\n    cursor: pointer;\r\n    background: transparent;\r\n    border: none;\r\n    padding: 0;\r\n    font: inherit;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
